import { render } from "./videoCard.vue?vue&type=template&id=31515f0b"
import script from "./videoCard.vue?vue&type=script&lang=js"
export * from "./videoCard.vue?vue&type=script&lang=js"

import "./videoCard.vue?vue&type=style&index=0&id=31515f0b&lang=css"

import exportComponent from "/Users/matjeez/Matjez/Projects/websites/simonkr-feb24/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__